<template>
  <div class="out-link">
    <ul>
      <li>
        <a
          href="https://www.facebook.com/pulip.comms"
          target="_blank"
        >Facebook</a>
      </li>
      <li>
        <a
          href="https://blog.naver.com/pulip_plog"
          target="_blank"
        >Blog</a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/pulip.comms"
          target="_blank"
        >Instagram</a>
      </li>
    </ul>
    <ul
      v-if="false"
      class="typeLang"
    >
      <li>
        <a
          active-class="none"
          exact
          @click.prevent="setLang('en')"
        >
          EN
        </a>
      </li>
      <li>
        <a
          active-class="none"
          exact
          @click.prevent="setLang('ko')"
        >
          KR
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'OutLink',
  computed: {
    ...mapState('common', {
      navigation: state => state.navigation
    })
  },
  methods: {
    ...mapActions('common', {
      setNavigationAction: 'setNavigation'
    }),
    setLang (c) {
      this.$cookies.set('lang', c)
      this.setNavigationAction(false)
      this.$i18n.locale = c
    }
  }
}
</script>
